import { Box, CircularProgress } from '@mui/material';

interface Props {
  when: boolean;
  children: React.ReactNode;
  height?: number;
  size?: number;
}

const ShowSpin = (props: Props) => {
  const { when, children, size = 40, height = 100 } = props;

  if (when) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height,
        }}
      >
        <CircularProgress size={size} />
      </Box>
    );
  }
  return <>{children}</>;
};

export default ShowSpin;
